<template>
  <div class="template" v-if="newAllBetEvent.od[plytyp]">
    <div v-for="btype in btypes" v-if="newAllBetEvent.od[plytyp][btype]" data-template="template3" class="wrap-template template3">
      <div class="main-handicap">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">{{ getTitleCaption() }}</span>
          </div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <div class="handicap">
            <div class="handicap-item m-oe os-1 no_border_bottom">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_YES'] }}</span>
                      </div>
                      <span class="ellipsis"></span>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="btype" ref="team1" :mode="'ab'" />
                </div>
              </div>
            </div>
            <div class="handicap-item m-oe os-1 no_border_bottom">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_NO'] }}</span>
                      </div>
                      <span class="ellipsis"></span>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="btype" ref="team2" :mode="'ab'" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import Odd1x2Components from '../../../components/odd1x2'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    bettyp: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().bttsBetType, allBetMixin.data().rbttsBetType, allBetMixin.data().exiBetType, allBetMixin.data().rexiBetType],
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = 'FT'
      var b = ''

      if(this.bettyp  == 76 || this.bettyp  == 79 ){
        
        b = this.sportAllBetLang['ALL_BET.SUBHEADER_EI']
      }else{

        if (this.plytyp == this.firstHtPlyType) {
          a = '1H'
        } else if (this.plytyp == this.SecondHtPlyType) {
          a = '2H'
        }

        b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
      }

      // RB score
      // if (this.newAllBetEvent.event_rb == 1) {
      //   b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
      // }
      return b
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, bttsBetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, bttsBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, bttsBetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, bttsBetType, this.isSpecial)
    },
    // oddsHeader(bttsBetType) {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.allBetEvent, bttsBetType)
    //   }
    //   return retCapt
    // },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-btts.vue